<template>
  <div>
    <div class="all">
      <div class="rel-graph">
        <SeeksRelationGraph
          ref="seeksRelationGraph"
          :options="graphOptions"
          :on-node-click="onNodeClick"
          :on-line-click="onLineClick"
        >
          <div
            slot="node"
            slot-scope="{ node }"
            @mouseover="showNode(node)"
            @mouseout="hideNode(node)"
          >
            <div class="root-style"></div>
            <div class="node-style">
              {{ node.data.myname }}
            </div>
          </div>
        </SeeksRelationGraph>
      </div>
      <div class="txt">
        <div class="txt-title">
          {{ txttitle }}
        </div>
        <vue-friendly-iframe
          ref="a1"
          className="txt-description"
          :src="txthtml"
          target="_blank"
          frameborder="1"
        ></vue-friendly-iframe>
      </div>
    </div>

    <button type="success" class="c-show-code-button">
      <a href="" style="color: #000000">返回主頁</a>
    </button>
    <button type="success" class="c-show-code-button" @click="popNode()">
      回上一節點
    </button>
    <button type="success" class="c-show-code-button">
      <a href="help.html" style="color: #000000">使用說明</a>
    </button>
    <button type="success" class="c-show-code-button">
      <a href="reference.html" style="color: #000000">參考文獻</a>
    </button>
    <!--el-drawer
      title="node option:"
      direction="rtl"
      size="50%"
      custom-class="c-drawer-window"
      :modal="false"
      :visible.sync="isShowCodePanel"
      :with-header="false"
    >
      <iframe src="/relation-graph-codes/Demo4Logo.html" width="100%" height="100%" frameborder="0" scrolling="auto" style="" />
    </! el-drawer> -->
  </div>
</template>

<script>
import SeeksRelationGraph from "relation-graph";
import axios from "axios";

export default {
  name: "App",
  components: {
    SeeksRelationGraph,
  },
  data() {
    return {
      txthtml: "",
      txthtml1: "",
      txttitle: "",
      clicknodes: [],
      nodeId: {},
      jsonData1: {},
      nodesJson: [],
      linksJson: [],
      nodes1Json: [],
      links1Json: [],
      currentNode: {},
      previousNode: {},
      isShowCodePanel: true,
      graphOptions: {
        allowShowMiniToolBar: false,
        disableDragNode: true,
        // disableZoom: true,
        hideNodeContentByZoom: true,
        allowSwitchLineShape: true,
        allowSwitchJunctionPoint: true,
        defaultNodeWidth: 6,
        defaultNodeHeight: 6,
        defaultLineShape: 5,
        defaultLineColor: "#dbd7d7",
        defaultNodeColor: "#ffffff",
        defaultNodeBorderColor: "#000000",
        defaultNodeBorderWidth: 2,
        // defaultLineWidth: 1,
        layouts: [
          {
            label: "布局1",
            layoutName: "center",
            layoutClassName: "seeks-layout-center",
            // useLayoutStyleOptions: true,
            // defaultNodeWidth: 50,
            // defaultNodeHeight: 50,
            defaultNodeBorderWidth: 0,
            // defaultNodeColor: 'rgba(238, 178, 94, 1)',
            defaultLineShape: 1,
            distance_coefficient: 0.5,
          },
        ],
        defaultJunctionPoint: "border",
        defaultLineMarker: {
          markerWidth: 15,
          markerHeight: 15,
          refX: 30,
          refY: 7,
          data: "",
        },
      },
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      try {
        let temp1 = await axios.get(
          process.env.VUE_APP_API_URL + "/nodes.json"
        );
        this.nodesJson = temp1.data;
        let temp2 = await axios.get(
          process.env.VUE_APP_API_URL + "/links.json"
        );
        this.linksJson = temp2.data;
        this.showSeeksGraph("root");
      } catch (error) {
        console.log(error);
      }
    },
    showSeeksGraph(nodeId) {
      let __graph_json_data = {
        rootId: nodeId,
        nodes: JSON.parse(JSON.stringify(this.nodesJson)),
        links: JSON.parse(JSON.stringify(this.linksJson)),
      };
      this.$refs.seeksRelationGraph.setJsonData(__graph_json_data, () => {
        this.$refs.seeksRelationGraph.graphData.nodes.forEach((element) => {
          if (element.lot.level > 2) {
            element.isHide = true;
          }
        });
        this.txttitle =
          this.$refs.seeksRelationGraph.graphData.rootNode.data.myname;
        this.txthtml =
          this.$refs.seeksRelationGraph.graphData.rootNode.data.txthtml;
        this.txthtml1 =
          this.$refs.seeksRelationGraph.graphData.rootNode.data.txthtml1;
        this.$refs.seeksRelationGraph.refresh();
      });
      this.jsonData1 = __graph_json_data;
      this.$refs.seeksRelationGraph.graphData.rootNode.borderColor = "#FF0000";
    },
    popNode() {
      this.clicknodes.pop();
      if (this.clicknodes.length == 0) {
        this.showSeeksGraph("root");
      } else {
        this.onNodeClick(this.clicknodes.pop());
      }
    },
    onNodeClick(nodeObject) {
      // console.log('nodeObject', nodeObject)
      // console.log('nodeID:', this.nodeId);
      // console.log('rootNode:', this.$refs.seeksRelationGraph.graphData.rootNode);
      this.clicknodes.push(nodeObject);
      // console.log('clicknodes:', this.clicknodes);
      if (
        this.$refs.seeksRelationGraph.graphData.rootNode != this.nodeId ||
        nodeObject.data.level != 3
      ) {
        this.nodeId = this.$refs.seeksRelationGraph.graphData.rootNode;
      }
      this.txthtml = nodeObject.data.txthtml;
      this.txthtml1 = nodeObject.data.txthtml1;
      this.txttitle = nodeObject.data.myname;
      let level = nodeObject.data.level;
      if (level == 3) return;
      let __graph_json_data = {
        rootId: nodeObject.id,
        nodes: JSON.parse(JSON.stringify(this.nodesJson)),
        links: JSON.parse(JSON.stringify(this.linksJson)),
      };
      this.$refs.seeksRelationGraph.setJsonData(__graph_json_data, () => {
        if (nodeObject.id == "root") {
          this.$refs.seeksRelationGraph.graphData.nodes.forEach((element) => {
            if (element.lot.level > 2) {
              element.isHide = true;
            }
          });
        }
      });
      this.$refs.seeksRelationGraph.graphData.nodes.forEach((element) => {
        // if(element.lot.level == 1 && element.data.level == 3) {
        //     element.isHide = true;
        // } else if (element.lot.level > 2) {
        //     element.isHide = true;
        // } else {
        //   element.isHide = false;
        // }
        // if(level == 2) {
        //   if(element.data.level == 1) {
        //     element.isHide = false;
        //   } else if (element.data.level ==3) {
        //     element.isHide = false;
        //   } else {
        //     element.isHide = true;
        //   }
        // }
        if (element.data.level < level) {
          element.isHide = true;
        } else if (element.data.level == level && element.lot.level == 2) {
          element.isHide = true;
        }
      });
      this.$refs.seeksRelationGraph.removeNodeById("root");
      this.$refs.seeksRelationGraph.refresh();
      // console.log(this.$refs.seeksRelationGraph.graphData)
      // this.$refs.seeksRelationGraph.graphData.nodes.forEach(element => {
      //   if(element.id =='root')
      //     element.targetTo.forEach(el => {
      //       if (el.text != nodeObject.text) {
      //         // this.$refs.seeksRelationGraph.removeNodeById(el.id);
      //         el.isHide = true;
      //       }
      //     });
      // });
      // this.$refs.seeksRelationGraph.removeNodeById("root");
      // this.$refs.seeksRelationGraph.graphData.nodes.forEach(element => {
      //   if (element.lot.level > 3) {
      //     // console.log(element.text);
      //     element.isHide = true;
      //   }
      // });
      // console.log(this.$refs.seeksRelationGraph.graphData);
    },
    onLineClick(lineObject) {
      console.log("onLineClick:", lineObject);
    },
    showNode(nodeObject) {
      let fromNode = nodeObject.id;
      nodeObject.color = "#437def";
      if (fromNode === "root") return;
      nodeObject.targetNodes.forEach((element) => {
        let toNode = element.id;
        if (toNode === "root") return;
        this.$refs.seeksRelationGraph.graphData.lines.forEach((line) => {
          if (line.fromNode.id == fromNode && line.toNode.id == toNode) {
            line.relations[0].color = "#437def";
          }
          if (line.fromNode.id == toNode && line.toNode.id == fromNode) {
            line.relations[0].color = "#437def";
          }
        });
      });
    },
    hideNode(nodeObject) {
      let fromNode = nodeObject.id;
      nodeObject.color = "#ffffff";
      nodeObject.targetNodes.forEach((element) => {
        let toNode = element.id;
        this.$refs.seeksRelationGraph.graphData.lines.forEach((line) => {
          if (line.fromNode.id == fromNode && line.toNode.id == toNode) {
            line.relations[0].color = "#dbd7d7";
          }
          if (line.fromNode.id == toNode && line.toNode.id == fromNode) {
            line.relations[0].color = "#dbd7d7";
          }
        });
      });
    },
    onLoad() {},
  },
};
</script>

<style>
* {
  font-family: "Microsoft JhengHei,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji";
}
.all {
  height: calc(100vh - 50px);
  display: flex;
}
.rel-graph {
  width: 900px;
}
.txt {
  height: calc(100vh - 50px);
  width: 100%;
  display: flex;
  flex-direction: column;
}

.txt-title {
  height: 100px;
  width: 90%;
  background-color: #bbb;
  color: white;
  font-size: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px 10px 0 0;
  padding: 10px;
}
.txt-description {
  display: block;
  width: 90%;
  padding: 10px;
  height: 800px;
  width: 90%;
  border: 2px solid black;
}
.txt-link1 {
  height: 100px;
  width: 90%;
  background-color: #bbb;
  color: white;
  font-size: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px 10px 0 0;
  padding: 10px;
}
.txt-link2 {
  padding: 10px;
  height: 200px;
  width: 90%;
  border: 1px solid black;
}

iframe {
  width: 100%;
  height: 100%;
}

.c-my-node {
  background-position: center center;
  background-size: 100%;
  border: 2px solid #ff8c00;
  height: 80px;
  width: 80px;
  border-radius: 40px;
}
.c-node-name {
  width: 160px;
  margin-left: -40px;
  text-align: center;
  font-size: 30px;
  margin-top: 85px;
  z-index: 99;
}
.node-style {
  color: black;
  background-color: white;
  font-size: 12px;
  position: absolute;
  width: 40px;
  line-height: 13px;
  margin: 16px 0 10px -16px;
  text-align: center;
  cursor: pointer;
}
.node-style:hover {
  color: "#437def";
  font-weight: bold;
}
.root-style {
}
</style>

<style lang="scss"></style>

<style lang="scss" scoped></style>
